import { Controller } from '@hotwired/stimulus'
import { template } from 'lodash'
import moment from 'moment'

export default class extends Controller {
  static targets = [
    'recurrencesLabel',
    'recurrencesForm',
    'recurrence',
    'availabilityButton',
    'dailyRecurrence',
    'price',
    'recurrencePrice',
    'startTime',
    'endTime',
    'recurrenceTitle',
    'recurrenceDate',
    'isAllDay',
    'recurrencesLabelTemplate',
    'availabilityButtonTemplate',
    'recurrenceFormTemplate',
    'dailyRecurrenceTemplate',
    'previousRecurrences'
  ]

  initialize() {
    this.timeFormat = 'HH:mm'
    this.dailyRecurrenceTemplate = template(this.dailyRecurrenceTemplateTarget.innerHTML)
    this.availabilityButtonTemplate = template(this.availabilityButtonTemplateTarget.innerHTML)
    this.recurrencesLabelTemplate = template(this.recurrencesLabelTemplateTarget.innerHTML)
    this.recurrenceFormTemplate = template(this.recurrenceFormTemplateTarget.innerHTML)
  }

  connect() {
    this.recurrencesLabelTarget.innerHTML = this.recurrencesLabelTemplate()
    if (this.isAllDayTarget.checked) {
      this.onAllDayTrue()
    } else {
      this.onAllDayFalse()
    }
  }

  onAllDayTrue() {
    this.recurrencesLabelTarget.innerHTML = ''
    this.recurrencesFieldsOff()
    if (document.querySelectorAll('#daily-recurrence-title').length === 0) {
      this.dailyRecurrenceTarget.innerHTML = this.dailyRecurrenceTemplate()
    }
  }

  onAllDayFalse() {
    this.recurrencesLabelTarget.innerHTML = this.recurrencesLabelTemplate()
    this.recurrencesFieldsOn()
    this.dailyRecurrenceTarget.innerHTML = ''
    this.availabilityButtonTarget.innerHTML = this.availabilityButtonTemplate()
    this.populateRecurrenceRows()
  }

  // should only be called when toggling to partial-day or after a schedule with a partial-day recurrence has failed to save
  populateRecurrenceRows() {
    const hiddenRecurrenceRowCount = document.querySelectorAll('#previous-recurrences .recurrence-row').length
    // this conditional determines if recurrences need to move from a hidden div to the form
    // if there are hidden recurrences on the page we want to move them to the form
    if (hiddenRecurrenceRowCount !== 0) {
      this.moveRecurrencesFromContainerToForm()
    }
    // this conditional adds the first pre-populated recurrence to the form if there are no existing recurrences
    if (this.recurrenceTargets.length === 0) {
      this.addFirstRecurrence()
    }
  }

  getRecurrenceTimeDifference(start, end) {
    start = moment(start, this.timeFormat)
    end = moment(end, this.timeFormat)
    return end.diff(start, 'minutes')
  }

  validateRecurrences() {
    let valid = true
    this.recurrenceDateTargets.forEach(target => {
      if (target.value === '') valid = false
    })
    this.recurrenceTitleTargets.forEach(target => {
      if (target.value === '') valid = false
    })
    return valid
  }

  addFirstRecurrence() {
    let recurrenceIndex
    let title = '8:00 AM'
    let start = '08:00'
    let end = '09:00'
    recurrenceIndex = '1'
    let content = this.recurrenceFormTemplate({ recurrenceIndex, title, start, end })

    this.recurrencesFormTarget.insertAdjacentHTML('beforeend', content)
    this.enableAddButton()
  }

  onAddRecurrence() {
    let recurrenceIndex
    const target = this.recurrencesFormTarget
    let start;
    let prevStart = this.startTimeTargets[this.startTimeTargets.length - 1].value
    let prevEnd = start = this.endTimeTargets[this.endTimeTargets.length - 1].value
    let interval = this.getRecurrenceTimeDifference(prevStart, prevEnd)
    let end = moment(start, this.timeFormat)
      .add(interval, 'minutes')
      .format(this.timeFormat)
    let title = moment(start, this.timeFormat).format('h:mm A')
    const last = this.recurrenceTargets[this.recurrenceTargets.length - 1]
    recurrenceIndex = (parseInt(last.dataset.recurrenceIndex) + 1).toString()
    let content = this.recurrenceFormTemplate({ recurrenceIndex, title, start, end })
    target.insertAdjacentHTML('beforeend', content)
    this.enableAddButton()
  }

  disableDeleteButton() {
    const recurrenceCount = this.recurrenceTargets.length
    document.querySelectorAll('.recurrence-delete-button').forEach(e => {
      if (recurrenceCount > 1) {
        e.style.display = ''
      } else {
        e.style.display = 'none'
      }
    })
  }

  onRemoveRecurrence() {
    const target = event.currentTarget
    const deleteIndex = target.dataset.deleteIndex
    for (let recurrence of this.recurrenceTargets) {
      if (deleteIndex === recurrence.dataset.recurrenceIndex) {
        recurrence.remove()
        break
      }
    }
    this.enableAddButton()
  }

  recurrencesFieldsOn() {
    const recurrences = document.querySelector('#partial-day')
    recurrences.style.display = ''
    this.disableDeleteButton()
  }

  recurrencesFieldsOff() {
    const recurrences = document.querySelector('#partial-day')
    recurrences.style.display = 'none'
    this.moveRecurrencesFromFormToContainer()
  }

  moveRecurrencesFromContainerToForm() {
    // there's a container div in the form html where we hide recurrences that have not
    // been persisted when toggling between full-day and partial-day in order to temporarily store them
    // this function extracts them from the hidden holding place back to the form when re-selecting partial-day
    const html = this.previousRecurrencesTarget.innerHTML
    this.recurrencesFormTarget.innerHTML = html
    this.previousRecurrencesTarget.innerHTML = ''
  }

  moveRecurrencesFromFormToContainer() {
    // this function does the reverse of moveRecurrencesFromContainerToForm()
    const html = this.recurrencesFormTarget.innerHTML
    this.previousRecurrencesTarget.innerHTML = html
    this.recurrencesFormTarget.innerHTML = ''
  }


  updateRecurrencePrice() {
    const price = this.priceTarget.value
    this.recurrencePriceTargets.forEach(e => {
      e.value = price * 100.0
    })
  }

  enableAddButton() {
    const button = document.querySelector('#add-button')
    const complete = this.validateRecurrences()
    if (complete) {
      button.disabled = false
    } else {
      button.disabled = true
    }
    this.disableDeleteButton()
  }

  submitForm() {
    this.updateRecurrencePrice()
  }
}
